// Honest placeholders for the navigation items and settings tabs of later sprints.
import { Link, useParams } from "react-router";
import { NAV } from "../shell/Sidebar";
import { PageHead, SETTINGS_TABS, SettingsTabs } from "./common";

export function Placeholder() {
  const { section } = useParams();
  const item = NAV.find((n) => n.key === section);
  if (!item) return <NotHere />;
  return (
    <section className="screen" id={`s-${item.key}`}>
      <div className="content">
        <PageHead title={item.label} />
        <div className="panel">
          <div className="empty">
            <b>{item.label} is not built yet.</b>
            <span>{item.sprint ? `Planned for Sprint ${item.sprint}.` : "Planned for a later sprint."} The sidebar keeps every module in its final place so the layout does not shift when it lands.</span>
            <div className="row c gap-8"><Link className="btn primary" to="/today">Back to Today</Link></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function SettingsPlaceholder() {
  const { tab } = useParams();
  const item = SETTINGS_TABS.find((t) => t.to === `/settings/${tab}`);
  if (!item) return <NotHere />;
  return (
    <section className="screen" id={`s-settings-${tab}`}>
      <div className="content">
        <PageHead title={item.label} sub="organisation-wide settings" />
        <SettingsTabs />
        <div className="panel">
          <div className="empty">
            <b>{item.label} settings are not built yet.</b>
            <span>{item.sprint ? `Planned for Sprint ${item.sprint}.` : "Planned for a later sprint."}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

/** "There is nothing at this address" — for a screen's own unknown sub-address (`/purchasing/<anything else>`). */
export function NotHereSection() { return <NotHere />; }

function NotHere() {
  return (
    <section className="screen" id="s-not-found">
      <div className="content">
        <PageHead title="Not found" />
        <div className="panel"><div className="empty"><b>There is nothing at this address.</b><div className="row c gap-8"><Link className="btn primary" to="/today">Back to Today</Link></div></div></div>
      </div>
    </section>
  );
}
